module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"upload":"Upload","choose":"Upload file","cancel":"Cancel","Удалить":"Remove","Ошибка":"Error","Идет загрузка":"Loading","Выбранные файлы":"Selected files","files_uploaded_hint":"Maximum files: {max}, uploaded: {uploaded}."},"ru":{"upload":"Загрузить","choose":"Добавить файл","cancel":"Отмена","files_uploaded_hint":"Максимальное количество файлов: {max}, загружено: {uploaded}."}}')
  delete Component.options._Ctor
}
